import { PictureElement } from '@/pictureElement/Picture';
import { rewriteImageSrc } from '@/utils/rewriteImageSrc';
import classnames from 'classnames';
import type { AuthorImagesElementProps } from './AuthorImages.types';

export function AuthorImagesElement(props: AuthorImagesElementProps) {
  const { element, children, attributes, className } = props;
  const { size, fill, authors } = element.attrs || {};

  return (
    <div className={classnames(className, 'relative')} {...attributes}>
      <div className="flex -space-x-1.5">
        {authors
          ?.map((author) => ({
            id: author.id,
            name: author.name,
            imgSrc: rewriteImageSrc(author?.profile_picture?.url),
          }))
          .map(({ id, name, imgSrc }) => {
            return (
              <div
                key={id}
                className={classnames('rounded-full')}
                style={{
                  width: size,
                  height: size,
                }}
              >
                <PictureElement src={imgSrc}>
                  <img
                    className={classnames('inline-block object-cover rounded-full')}
                    src={imgSrc}
                    alt={name}
                    style={{
                      border: `1px solid ${fill}`,
                      width: size,
                      height: size,
                    }}
                  />
                </PictureElement>
              </div>
            );
          })}
      </div>
      {children}
    </div>
  );
}
